"use client";

interface NameFormProps {
  name: string;
  onNameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function NameForm({ name, onNameChange, onSubmit }: NameFormProps) {
  return (
    <>
      <section
        className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8"
        aria-label="Name numerology calculator result details"
      >
        {[
          ["Name Number", "Single-digit value from your full name"],
          ["Letter Breakdown", "A=1 to I=9 Pythagorean mapping"],
          ["Planet + Career", "Ruling graha, traits and lucky day"],
        ].map(([label, value]) => (
          <div key={label} className="rounded-lg border border-ish-border bg-ish-bg-card p-4">
            <p className="text-[13px] font-semibold text-ish-dark">{label}</p>
            <p className="text-[12px] mt-1 text-ish-muted">{value}</p>
          </div>
        ))}
      </section>

      <form onSubmit={onSubmit} className="max-w-md mx-auto">
        <div className="card-sacred p-6 sm:p-8">
          <label className="block text-[13px] font-semibold mb-2 text-ish-dark">
            Enter Your Full Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. Rahul Sharma"
            className="w-full px-4 py-3 rounded-lg text-[15px] outline-none border border-ish-border bg-white text-ish-dark focus:border-ish-accent transition-all duration-200"
            autoFocus
          />
          <p className="text-[12px] mt-2 text-ish-faint">
            Use English letters only. Spaces and special characters are ignored.
          </p>
          <button
            type="submit"
            className="btn-sacred w-full mt-4 py-3 rounded-lg text-[14px] font-semibold disabled:opacity-50"
            disabled={name.trim().length === 0}
          >
            Calculate Name Number
          </button>
        </div>
      </form>
    </>
  );
}
